import API from "shared/services/Api";
import { IPDFDownload } from "shared/types/PdfDownload";

export const pdfDownload = async (data: IPDFDownload, userId: string) =>
  API.post(`oc/referrals/pdf-by-patient?id=${userId}`, data);
